import React from 'react';
import { Icon } from '@lana-ui/common';
import '@styles/Features/beneficios.scss';

const Beneficios = ({ features, featuresBonificada }) => {
    return (
        <>
            {features && <div className="beneficios" dangerouslySetInnerHTML={{ __html: features }}></div>}
            {featuresBonificada && (
                <div className="beneficios">
                    <p className='--mb-4'>
                        <Icon icon="checkmark" size="s" />
                        <span>Acceder a las notas sin límite mensual</span>
                    </p>
                    <p className='--mb-4'>
                        <Icon icon="checkmark" size="s" />
                        <span>Acceder a notas exclusivas</span>
                    </p>
                    <p>
                        <Icon icon="checkmark" size="s" />
                        <span>Acceder a la edición impresa en pdf y a las revistas</span>
                    </p>
                </div>
            )}
        </>
    );
};

export default Beneficios;
